import script from "./Internacao.vue?vue&type=script&setup=true&lang=js"
export * from "./Internacao.vue?vue&type=script&setup=true&lang=js"

import "./Internacao.vue?vue&type=style&index=0&id=34ea2f9a&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ea2f9a"]])

export default __exports__